"use client"
import { Button } from "./button";
import { Icon } from "./icon";
import { DialogHeader, DialogFooter, Dialog, DialogContent, DialogTitle, DialogDescription, DialogClose } from "./ui/dialog";

interface ModalProps {
    title: string;
    children: React.ReactNode;
    closeButton?: ModalButtonProps;
    buttons?: ModalButtonProps[];
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
}

interface ModalButtonProps {
    onClick?: () => void;
    label: string;
}

export function Modal({title, closeButton, buttons, children, isOpen, onOpenChange}: ModalProps) {
    return (
        <Dialog onOpenChange={onOpenChange} open={isOpen}>
            <DialogContent>
                <DialogHeader className="flex flex-row items-center justify-between">
                    <DialogTitle>{title}</DialogTitle>
                    <DialogClose asChild>
                        <button onClick={closeButton?.onClick}>
                            <Icon icon="MdClose" size={20} className="fill-secondary cursor-pointer"/>
                        </button>
                    </DialogClose>
                </DialogHeader>
                <hr className="w-auto border-1 border-card-header -ml-3 -mr-3"/>
                <DialogDescription asChild>
                    {children}
                </DialogDescription>
                {(closeButton || buttons) &&
                    <>
                        <hr className="w-auto border-1 border-card-header -ml-3 -mr-3"/>
                        <DialogFooter>
                            {closeButton && 
                                <DialogClose asChild>
                                    <Button variant="outlined-primary" onClick={closeButton.onClick}>
                                        {closeButton.label}
                                    </Button>
                                </DialogClose>
                            }
                            {buttons?.map(button => (
                                <DialogClose asChild key={button.label}>
                                    <Button onClick={button.onClick}>
                                        {button.label}
                                    </Button>
                                </DialogClose>
                            ))}
                        </DialogFooter>
                    </>
                }
            </DialogContent>
        </Dialog>
    )
}